import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/layout/app-layout/app-layout';
import DeadlinesTab from './DeadlinesTab';

const PageDeadlinesMessages: FC = () => {
  const [t] = useTranslation('dashboard');

  return (
    <AppLayout title={t('deadlinesMessages.pageTitle', 'Att göra')}>
      <div style={{ padding: '16px 32px' }}>
        <DeadlinesTab />
      </div>
    </AppLayout>
  );
};

export default PageDeadlinesMessages;
